import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Ocorrencia } from '../modelo/Ocorrencia';
import { Observable } from 'rxjs';
import { Projeto } from '../modelo/Projeto';

@Injectable({
    providedIn: 'root'
  })
  export class OcorrenciaService {

    apiUrl: string = `${environment.backendUrl}/ocorrencias`;

    constructor(private http: HttpClient) { }
  
      httpOptions = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
  
      httpOptionsMultiPart = {
        headers: {
            //'Content-Type': 'application/json',
        }
    }

    getPorProjeto(projetoId: String | undefined | null) {
      if (projetoId == undefined || projetoId == null)
        return this.http.get<Ocorrencia[]>(`${this.apiUrl}`,
        { headers: this.httpOptions.headers });
      else
        return this.http.get<Ocorrencia[]>(`${this.apiUrl}/${projetoId}`,
        { headers: this.httpOptions.headers });

    }

    get(){
        return this.http.get<Ocorrencia[]>(`${this.apiUrl}`,
        { headers: this.httpOptions.headers });
      }

    put( ocorrencia: Ocorrencia): Observable<any>{
        return this.http.put(`${this.apiUrl}/${ocorrencia.id}`, 
        ocorrencia, { headers: this.httpOptions.headers });
      }
  
  }
